import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '子项目',
    type: 'SUB_PRJ',
}